(function () {
    var atcTime = 0.5;
    var productCost = 800;
    var workingDaysPerYear = 250;

    function fmt(n) {
        return n >= 1000 ? '$' + Math.round(n).toLocaleString() : '$' + Math.round(n);
    }

    function init(el) {
        function getSlider(key) {
            return el.querySelector('[data-roi="' + key + '"]');
        }

        function getDisplay(key) {
            return el.querySelector('[data-roi-display="' + key + '"]');
        }

        function getOutput(key) {
            return el.querySelector('[data-roi-output="' + key + '"]');
        }

        function calc() {
            var changes = +getSlider('changes').value;
            var jobs    = +getSlider('jobs').value;
            var manual  = +getSlider('manualTime').value;
            var rate    = +getSlider('rate').value;

            var savedPerChange = manual - atcTime;
            var totalSavedMin  = Math.round(savedPerChange * changes * jobs);
            var totalSavedHrs  = (totalSavedMin / 60).toFixed(1);
            var dailyDollars   = (totalSavedMin / 60) * rate;
            var yearlyDollars  = dailyDollars * workingDaysPerYear;
            var paybackDays    = dailyDollars > 0 ? Math.round(productCost / dailyDollars) : 0;

            getOutput('timeSaved').textContent  = totalSavedMin + ' min';
            getOutput('hrsSaved').textContent   = totalSavedHrs + ' hrs';
            getOutput('dailySaved').textContent  = fmt(dailyDollars);
            getOutput('yearlySaved').textContent = fmt(yearlyDollars);
            getOutput('payback').textContent     = paybackDays > 0 ? paybackDays + ' working days' : '—';
        }

        function syncDisplay(key) {
            var display = getDisplay(key);
            if (display) {
                display.textContent = getSlider(key).value;
            }
        }

        ['changes', 'jobs', 'manualTime', 'rate'].forEach(function (key) {
            var slider = getSlider(key);
            if (!slider) return;

            slider.addEventListener('input', function () {
                syncDisplay(key);
                calc();
            });
        });

        calc();
    }

    document.querySelectorAll('.rcatc-roi-calculator').forEach(init);
})();
